import { inject, Injectable } from '@angular/core';
import { CommonService } from '../common.service';
import { Observable } from 'rxjs';
import { TaxonomyRequest, TaxonomyResponse, TaxonomyCreateRequest, TaxonomyDeleteRequest, EntityUpdateRequest, TaxonomyUpdateRequest, TaxonomyPublishRequest } from '../../pages/taxonomy-dashboard-v2/taxonomy.model';

@Injectable({
  providedIn: 'root',
})
export class TaxonomyApiService {
  public commonService = inject(CommonService);

  taxonomyPutBody = [];

  constructor() {}

  updateTaxonomy(body: TaxonomyRequest, id: string): Observable<any> {
    return this.commonService.postRequest(`taxonomy/update-item?uuid=${id}`, body);
  }

  deleteTaxonomy(body: { id: string }): Observable<any> {
    return this.commonService.postRequest(`taxonomy/delete-item?uuid=${body.id}`, body);
  }

  // TAXONOMY VERSION 2 - API CALLS - CRUD TAXONOMY

  createTaxomonyV2(body: TaxonomyCreateRequest): Observable<any> {
    return this.commonService.postRequest('user/create-taxonomy', body);
  }

  getTaxonomyV2(body: any): Observable<TaxonomyResponse> {
    return this.commonService.postRequest('user/get-all-taxonomies', body);
  }

  deleteTaxonomyV2(body: TaxonomyDeleteRequest): Observable<any> {
    return this.commonService.postRequest('user/delete-taxonomy', body);
  }

  getEntitiesV2ByTaxonomyId(body: any): Observable<any> {
    return this.commonService.postRequest('user/get-all-entities', body);
  }

  getSpecificTaxonomyV2ById(body: any): Observable<any> {
    return this.commonService.postRequest('user/get-taxonomy-by-id', body);
  }

  updateTaxonomyV2(body: any): Observable<TaxonomyUpdateRequest> {
    return this.commonService.postRequest('user/update-taxonomy', body);
  }

  publishTaxonomyV2(body: any): Observable<TaxonomyPublishRequest> {
    return this.commonService.postRequest('user/publish-taxonomy', body);
  }

  //TAXONOMY VERSION 2 - API CALLS - CRUD ENTITIES

  addEntityV2(body: TaxonomyRequest): Observable<any> {
    return this.commonService.postRequest('user/create-entity', body);
  }

  updateEntityV2(body: EntityUpdateRequest): Observable<any> {
    return this.commonService.postRequest('user/update-entity', body);
  }

  deleteEntityV2(body: { id: string }): Observable<any> {
    return this.commonService.postRequest('user/delete-entity', body);
  }

  getEnitityByIdV2(body:{entity_id: string , taxonomy_id:string}){
    return this.commonService.postRequest('user/get-entity-by-id', body);
  }

  // GENERAL SETTING SECTION

  getListOfQueueGroups(body:{}){
    return this.commonService.postRequest('user/get-queue-groups', body);
  }
}
